import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const retool = defineConnector({
  identifier: "retool",
  name: "Retool",
  tagLine: "Internal tools builder",
  logo,
  protocol: "http",
  tags: ["engineering", "productivity"],
  defaultUrlPattern: () => "https://api\\.retool\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Retool](https://retool.com/) and navigate to **Settings** > **API** to create a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Retool API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.retool.com/api/v1/users/current",
  },
});
